import React from "react";
import { InputMascaraDinamica } from "./InputMascaraDinamica";


export type InputTelefoneCelularProps = {
    telefoneCelular:string,
    onTelefoneCelularModificado: (telefoneCelular:string) => void
    emitirComMascara?: boolean
    placeholder?: string
    disabled?:boolean
    className?: string
    id?: string
    style?: React.CSSProperties
}

export const InputTelefoneCelular = (props: InputTelefoneCelularProps) => <InputMascaraDinamica
    placeholder={props.placeholder}
    className={props.className}
    mascaras={props.telefoneCelular?.startsWith("0") ?  ["(999) 9999-9999", "(999) 99999-9999"] : ["(99) 9999-9999","(99) 99999-9999",]}
    type="tel"
    emitirComMascara={props.emitirComMascara === undefined || props.emitirComMascara === true}
    onValorModificado={props.onTelefoneCelularModificado}
    valor={props.telefoneCelular ?? ''}
    id={props.id || undefined}
    disabled={props.disabled}
    style={props.style}/>